import { styled, Box } from "@mui/material";


export const TitleText = styled(Box)(({ theme }) => ({
    marginRight:"auto",
    textAlign:'left',
    fontFamily: 'FinancierDisplay',
    fontSize: '2.5rem',
    overflow: 'hidden',
    color: 'var(--green)',
    cursor: 'default',
  }));
  
  
  
  export const Action = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
  }));